<template>
  <div class="oocarousel-navigation">
	<button
		type="button"
		aria-label="Previous page"
		:tabindex="canAdvanceBackward ? 0 : -1"
		class="oocarousel-navigation-button oocarousel-navigation-prev"
		v-on:click.prevent="triggerPageAdvance('backward')"
		v-bind:class="{ 'oocarousel-navigation--disabled': !canAdvanceBackward }"
		v-bind:style="`padding: ${clickTargetSize}px; margin-right: -${clickTargetSize}px;`">
		<!-- v-html="prevLabel" -->
		<span>
			❮
		</span>
	</button>
	<button
		type="button"
		aria-label="Next page"
		:tabindex="canAdvanceForward ? 0 : -1"
		class="oocarousel-navigation-button oocarousel-navigation-next"
		v-on:click.prevent="triggerPageAdvance('forward')"
		v-bind:class="{ 'oocarousel-navigation--disabled': !canAdvanceForward }"
		v-bind:style="`padding: ${clickTargetSize}px; margin-left: -${clickTargetSize}px;`">
		<!-- v-html="nextLabel" -->
		<span>
			❯
		</span>
	</button>
  </div>
</template>

<script>
export default {
	name: 'navigation',
	inject: ['carousel'],
	props: {
		/**
	 * Amount of padding to apply around the label in pixels
	 */
		clickTargetSize: {
			type: Number,
			default: 8,
		},
		/**
	 * Text content of the navigation next button
	 */
		nextLabel: {
			type: String,
			default: '&#9654',
		},
		/**
	 * Text content of the navigation prev button
	 */
		prevLabel: {
			type: String,
			default: '&#9664',
		},
	},
	computed: {
		/**
	 * @return {Boolean} Can the slider move forward?
	 */
		canAdvanceForward() {
			return this.carousel.canAdvanceForward || false;
		},
		/**
	 * @return {Boolean} Can the slider move backward?
	 */
		canAdvanceBackward() {
			return this.carousel.canAdvanceBackward || false;
		},
	},
	methods: {
		/**
	 * Trigger page change on +/- 1 depending on the direction
	 * @param {"backward"} [direction]
	 * @return {void}
	 */
		triggerPageAdvance(direction) {
			/**
	   * @event paginationclick
	   * @type {string}
	   */
			this.$emit('navigationclick', direction);
		},
	},
};
</script>

<style lang="scss" scoped>
.oocarousel-navigation-button {
	position: absolute;
	top: 40%;
	box-sizing: border-box;
	color: #000;
	text-decoration: none;
	appearance: none;
	border: none;
	background-color: transparent;
	padding: 0;
	cursor: pointer;
	outline: none;
	transform: translateY(-50%);

	&:focus {
		outline: 1px solid lightblue;
	}
}


.oocarousel-navigation-next {
	right: 0;
	// transform: translateY(-50%) translateX(100%);
	font-family: "system";
}

.oocarousel-navigation-prev {
	left: 0;
	// transform: translateY(-50%) translateX(-100%);
	// transform: translateY(-50%);
	font-family: "system";
}

.oocarousel-navigation--disabled {
	opacity: 0.5;
	cursor: default;
}

/* Define the "system" font family */
@font-face {
	font-family: system;
	font-style: normal;
	font-weight: 300;
	src: local(".SFNSText-Light"), local(".HelveticaNeueDeskInterface-Light"),
		local(".LucidaGrandeUI"), local("Ubuntu Light"), local("Segoe UI Symbol"),
		local("Roboto-Light"), local("DroidSans"), local("Tahoma");
}
</style>
